import { createSelector, createStructuredSelector } from "reselect";

export const authSelector = state => state.auth.toJS();

export const isLoggedInSelector = createSelector(
  authSelector,
  auth => auth.isSignedIn
);

export const userSelector = createSelector(
  authSelector,
  auth => auth.user || null
);

export const userNameSelector = createSelector(
  userSelector,
  user => user?.name || null
);
export const userEmailSelector = createSelector(
  userSelector,
  user => user?.email || null
);
export const userPhotoSelector = createSelector(
  userSelector,
  user => user?.picture || null
);
export const allowedWorkareaSelector = createSelector(
  userSelector,
  user => user?.workareas || []
); // return empty array if undefined
export const allowedOrganizationsSelector = createSelector(
  userSelector,
  user => user?.organizations || []
); // return empty array if undefined

export const allowedAccessSelector = createSelector(
  userSelector,
  user =>
    user?.groups.includes("eims.users@hakai.org") ||
    user?.groups.includes("eims.editors@hakai.org") ||
    false
);
export default createStructuredSelector({
  userName: userNameSelector,
  userEmail: userEmailSelector,
  userPhoto: userPhotoSelector,
  allowedWorkareas: allowedWorkareaSelector,
  allowedOrganizations: allowedOrganizationsSelector,
  allowedAccess: allowedAccessSelector
});
